import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';
import { FlexCol } from '~/modules/artist-roster/components/flex/FlexCol';
import { MusicIqTitle } from '~/modules/music-iq/pages/chatbot-page/components/MusicIqTitle';

import { DEFAULT_QUESTION_KEYS } from './constants';

export interface DefaultQuestionsProps {
  onQuestionSelected: (question: string) => void;
}

export function DefaultQuestions({
  onQuestionSelected,
}: DefaultQuestionsProps) {
  const { t } = useTranslation('data');

  const questions = useMemo(
    () => DEFAULT_QUESTION_KEYS.map((key) => t(key)),
    [t],
  );

  return (
    <FlexCol className="w-full items-center gap-lg">
      <FlexCol className="w-full items-center gap-xs text-center">
        <MusicIqTitle />
        <p className="text-display-md font-bold">
          {t('musicIq.defaultQuestions.description')}
        </p>
      </FlexCol>
      <FlexCol className="w-full items-center gap-sm">
        {questions.map((question, index) => (
          <button
            key={index}
            type="button"
            onClick={() => onQuestionSelected(question)}
            className={cn(
              'w-full',
              'rounded-sm',
              'border border-emphasis-subtle',
              'bg-emphasis-default',
              'p-md',
              'text-left text-body-sm leading-tight text-strong',
              'duration-300',
              'hover:bg-emphasis-strong hover:border-emphasis-default',
              'focus:outline-none',
            )}
          >
            {question}
          </button>
        ))}
      </FlexCol>
    </FlexCol>
  );
}

DefaultQuestions.displayName = 'DefaultQuestions';
